import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {

  constructor(private afAuth: AngularFireAuth, private router: Router) {}
  public isadmin: boolean = false;
  canActivate() {
    return this.afAuth.idTokenResult.pipe(
      map(idTokenResult => {
        // Check if idTokenResult is not null and the 'admin' claim is true
        if (idTokenResult && idTokenResult.claims?.['role'] == 'Admin') {
          this.isadmin = true;
          return true;
        } else {
          // Navigate to a 'not authorized' or 'home' page if not admin or if idTokenResult is null
          this.router.navigate(['/login']);
          return false;
        }
      }),
      catchError(() => {
        this.router.navigate(['/login']);
        return of(false);
      })
    );
  }
}
